$(document).ready(function() {
    const headerHeight = $('.standard-header .site-header').outerHeight() + 'px';
    $('body').css('padding-top', headerHeight);

    $(window).resize(function() {
        var headerHeight = $('.standard-header .site-header').outerHeight() + 'px';
        $('body').css('padding-top', headerHeight);
    });
});
